module.exports = __webpack_public_path__ + "img/Delta-icon.d7452567.png";